import React from "react";

import background from '@cover/weiterlernen/background-1.jpg';
import backgroundSm from '@cover/weiterlernen/background-1-sm.jpg';
import background2 from '@cover/weiterlernen/background-2.png';
import background2Sm from '@cover/weiterlernen/background-2-sm.png';
import WeiterLernen from "../components/cover/animations/weiterlernen";

import articleSrc from '@assets/article.svg';

export const meta = {
	category: "continue",
	slug: "lernen",
	id: "WeiterLernen",
	excerpt: {
		before: "Arichika Ohara ist Student der Gifu Academy of Forest Science and Culture in Japan. Von 2019 bis 2020 war der 30-Jährige Stipendiat des ",
		italic: "BW-STIPENDIUMs ",
		after: "an der Hochschule für Forstwirtschaft Rottenburg am Neckar. Seine Vision: zur Reform der japanischen Waldwirtschaft beizutragen."
	},
	name: "weiterlernen",
	title: "Die Götter des Waldes",
	animation: WeiterLernen,
	cover: {
		background: {
			lg: background,
			sm: backgroundSm
		},
		layers: [
			{
				src: {
					lg: background2,
					sm: background2Sm
				},
				zIndex: 666,
			}
		],
		alt: "Arichika Ohara, Stipendiat des BW-Stipendiums, lächelt, inmitten eines Walds aus Blumen, Bäumen und Sträuchern. Auf seinem Shirt ist eine geteilte Flagge gemalt: Deutschland und Japan."
	}
}

const WeiterlernenArticle = () => {
	return (
		<div>
			<p className="articleParagraph">
				Arichika Ohara hat im Rahmen des <i>Baden-Württemberg STIPENDIUMs</i> an der Hochschule für Forstwirtschaft Rottenburg am Neckar (HFR) studiert. Mit seinen neu erworbenen Kenntnissen möchte der 30-Jährige nichts Geringeres, als die japanische Forstwirtschaft reformieren.   
			</p>
			<p className="articleQuestion">
				Welche Bedeutung hat der Wald in Japan?
			</p>
			<p className="articleAnswer">
				Er ist ein spiritueller Ort. Der Shintō ist bei uns eine wichtige Religion. Ihre Grundidee ist die der „acht Millionen Götter“, <i>yaoyorozu no kami</i>. Das bedeutet, dass es überall Götter gibt. In einem Stein. In einem Tisch. In einem Baum. Im Reis. In der Küche. Der Wald ist die natürliche Wohnstätte dieser Götter. Deshalb steht dort ein Schrein. Meine Hochschule feiert jedes Jahr ein Ritual in dem Wald, der ihr zur Forschung zur Verfügung steht. Wir ehren damit den Gott des Waldes, <i>yama no kami</i>. 
			</p>
			<p className="articleQuestion">
				Sie haben von Juni 2019 bis August 2020 an der HFR studiert. Was hat Sie motiviert, ein Austauschjahr ausgerechnet in Baden-Württemberg zu machen?
			</p>
			<p className="articleAnswer">
				Je länger ich Forstwirtschaft in Gifu studierte, desto größer wurde mein Wunsch, meine Kenntnisse in Deutschland zu vertiefen. Denn hier gibt es ein ausgezeichnetes Ausbildungssystem für Forstwirtschaft. Meine Hochschule hatte zum Glück mit der HFR ein Abkommen geschlossen, deshalb konnte ich in Rottenburg studieren.
			</p>
			<p className="articleQuestion">
				Woher kommt Ihr Interesse für die Forstwirtschaft? 
			</p>
			<p className="articleAnswer">
				Sie müssen wissen: Zwei Drittel der Fläche Japans sind bewaldet. Der Holzvorrat ist beachtlich und beträgt mehr als fünf Milliarden Kubikmeter. Trotzdem ist die Versorgungsquote mit heimischen Hölzern sehr niedrig. Was dazu führt, dass Japan Holz importiert. Das möchte ich ändern. Ich glaube, dass die japanische Forstwirtschaft große Potenziale hat. Wenn es gelingt, gute Systeme und Methoden aufzustellen, lassen sich die Wälder besser pflegen, eine nachhaltige Bewirtschaftung aufbauen und Arbeitsplätze schaffen. 
			</p>
			<p className="articleQuestion">
				Welches Forschungsziel haben Sie in Deutschland verfolgt? 
			</p>
			<p className="articleAnswer">
				Ich wollte herausfinden, wie die Privatwälder in Baden-Württemberg bewirtschaftet werden. Ich möchte Ihnen gern die Gründe erklären. In Japan ist mehr als die Hälfte des Waldes in Privatbesitz. Davon sind 25 Prozent Kleinwaldbesitzer, die Parzelle ist nur ein bis fünf Hektar groß. In Baden-Württemberg liegen gut 36 Prozent des Waldes in privater Hand und etwa ein Drittel davon sind Kleinwaldbesitzer. Die Flächenunterschiede beider Länder sind also nicht allzu groß. Allerdings werden die kleinen Wälder in Japan schlecht bewirtschaftet. 
			</p>
			<p className="articleQuestion">
				Warum? 
			</p>
			<p className="articleAnswer">
				Das kann viele Gründe haben. Zum Beispiel sind die Besitzverhältnisse ungeklärt oder die Waldbesitzer können ihre Parzellengrenzen nicht erkennen und deshalb bleibt das Gelände ungenutzt. Das ist ein großes Problem, weil auch die Behörde keine Eintragungen hat. In Deutschland kennt der Förster die Besitzverhältnisse in seinem Revier. Bei uns gibt es zwar auch Förster, sinrinkan, aber die sind für den Staatswald und nicht für Privat- oder Gemeinschaftswälder zuständig. Es gibt auch keine anderen Fachleute für Privatwälder und die Forstbetriebsgemeinschaften funktionieren in vielen Regionen nicht. 
			</p>
			<p className="articleQuestion">
				Haben Sie sich Privatwälder in Baden-Württemberg angesehen? 
			</p>
			<p className="articleAnswer">
				Oh, ja! Herr Tänzer, ein Förster im Landkreis Tübingen, hat mir die Privatwälder gezeigt, für die er zuständig ist. Ich hätte mir nie träumen lassen, dass sich in Deutschland so kleine Privatwälder befinden! Sie messen durchschnittlich nur 0,1 Hektar. Zu meinem großen Erstaunen habe ich erfahren, dass alle Parzellen eine feste Grenze haben, obwohl sie so klein sind. In Baden-Württemberg können sich alle Waldbesitzer vom Förster beraten lassen. Ich habe angenommen, dass seine Unterstützung eine große Rolle für die Bewirtschaftung von Privatwäldern spielt. Das habe ich zum Thema meiner Abschlussarbeit gemacht.  
			</p>
			<p className="articleQuestion">
				Für die Sie mit dem „Ehrenpreis des Rektors“ ausgezeichnet wurden. Was bedeutet Ihnen diese Auszeichnung?  
			</p>
			<p className="articleAnswer">
				Diese Auszeichnung hat eine ganz besondere Bedeutung für mich, denn sie ist ein Beleg dafür, dass all meine Leistungen vom Rektor anerkannt wurden. Daher war es eine große Ehre für mich, sie zu erhalten. 
			</p>
			<p className="articleQuestion">
				Was können japanische von baden-württembergischen Waldbesitzern lernen? 
			</p>
			<p className="articleAnswer">
				Leider kann ich diese Frage nicht beantworten, weil ich nur Professoren, Förster und eine Oberförsterin befragt habe. Aber ich möchte gern versuchen, Ihre Frage aus einer anderen Sicht zu beantworten. Es scheint ein sehr gutes System zu sein, dass es für alle Regionen in Baden-Württemberg Förster gibt. Er ist der Fachmann für Forstwirtschaft und wohnt in dem Revier, für das er zuständig ist. Das ist sehr wichtig, denn er kennt die Region sehr gut. Und er kann mit den Waldbesitzern ein Vertrauensverhältnis aufbauen. Wenn der Besitzer Schwierigkeiten oder Fragen hat, steht ihm der Förster jederzeit zur Verfügung. 
			</p>
			<p className="articleQuestion">
				Während Ihres Studiums in Deutschland ist der Corona-Virus ausgebrochen. Wie ging es Ihnen damit so fern von zu Hause?
			</p>
			<p className="articleAnswer">
				Beim ersten Lockdown hatte ich große Angst vor dem Virus und der Situation, der ich auf einmal gegenüberstand. Ich wollte aber nicht nach Japan zurückkehren, weil ich mein Auslandsstudium unbedingt mit meiner Abschlussarbeit und der Prüfung an der Hochschule beenden wollte. Die Mitarbeiterinnen und Mitarbeiter und die Professoren haben sich sehr um mich gekümmert. Aber auch die Menschen von Rottenburg, die ich traf, wie die Verkäuferinnen und Verkäufer im Supermarkt, der Apotheke, der Bäcker und der Metzger waren freundlich und hilfsbereit. Ich bin in dieser Zeit oft in der Umgebung spazieren gegangen oder mit dem Fahrrad gefahren und konnte dadurch sehr schöne Orte kennenlernen. Die deutsche Landschaft hat mich sehr beeindruckt. Vor allem die Felder, die sich bis in die Ferne erstrecken. 
			</p>
			<p className="articleQuestion">
				Die Präsenzveranstaltungen an der Uni sind also ausgefallen? 
			</p>
			<p className="articleAnswer">
				Ja, nachdem die Corona-Erkrankungen um sich gegriffen haben, wurden die Seminare online durchgeführt. Die Vorlesungen und Exkursionen wurden aufgenommen, dadurch habe ich viele neue Kenntnisse erworben, weil ich die Videos immer wieder abspielen konnte. Außerdem hatte ich die Gelegenheit bekommen, als studentische Hilfskraft Filme über den Waldbau mit japanischen Untertiteln zu versehen. Die Filme wurden später unter anderem auch meiner Hochschule zur Verfügung gestellt. Ich habe sogar an einem Projekt meines Professors teilgenommen, das vom Bundesministerium für Ernährung und Landwirtschaft gefördert wird. Als Teil des Teams habe ich Anbauversuche japanischer Baumarten in Baden-Württemberg und Bayern besucht. Das war mir eine große Freude. Dadurch konnte ich meinen Horizont erweitern und viele persönliche Beziehungen aufbauen. 
			</p>
			<p className="articleQuestion">
				Welche Erfahrungen haben Sie von Ihrem Studium in Deutschland mitgenommen? 
			</p>
			<p className="articleAnswer">
				Es hat mich sehr erstaunt, dass die Studierenden der HFR umfassende Übungen durchführen und sich umfangreiche Kenntnisse aneignen. Sie müssen die Namen von Bäumen, aber auch von Kräutern und Gräsern und sogar von Moosen lernen. Und sie müssen die Bezeichnungen mit den soziologisch-ökologischen Artengruppen verbinden können. Besonders beeindruckt hat mich, dass die deutsche Sprache in der Forstwirtschaft sehr viele Fachwörter hat. Beispielsweise gibt es verschiedene Wörter für den Waldrand wie „Saum“, „Mantel“ oder „Trauf“. 
			</p>
			<p className="articleQuestion">
				Wie sehen Ihre Pläne für die Zukunft aus? 
			</p>
			<p className="articleAnswer">
				Ich möchte sehr gern in der Forstwirtschaft arbeiten und zu den Reformbemühungen in Japan beitragen. Dafür möchte ich die Kenntnisse, die ich in Deutschland erworben habe, in Japan umsetzen. Dafür muss ich aber noch viel lernen. Daher möchte ich noch einmal nach Deutschland zurückkehren, um weiter an der HFR zu studieren.
			</p>
			<a href="https://www.bw-stipendium.de/startseite/" target="_blank" className="articleLink articleLink--block">
			 <div className="articleLinkIcon">
					<img src={articleSrc} />
				</div>
				<div>
					Baden-Württemberg STIPENDIUM
					<div className="articleLinkSource">
						bw-stipendium.de
					</div>
				</div>
			</a>
		</div>
	)
};

export default WeiterlernenArticle;